import { render, staticRenderFns } from "./ArStartSticker.vue?vue&type=template&id=50ebd97e&"
import script from "./ArStartSticker.vue?vue&type=script&lang=ts&"
export * from "./ArStartSticker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports